import ReactGA from 'react-ga';
import { EnvironmentConfig } from './environment-config';

export const initGoogleAnalytics = () => {
  if (!EnvironmentConfig.googleAnalyticsTrackingId) {
    return;
  }
  ReactGA.initialize(EnvironmentConfig.googleAnalyticsTrackingId);
};
